import React, { FC, SVGProps } from 'react'
import SVGUniqueID from 'react-svg-unique-id'

interface BlurBlueCircleProps extends SVGProps<SVGSVGElement> {
  width?: number
  height?: number
}

const BlurBlueCircle: FC<BlurBlueCircleProps> = ({
  width = 160,
  height = 93
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 160 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.24} filter="url(#filter0_f_407_8583)">
        <circle
          cx={53.5}
          cy={49.4802}
          r={66.5}
          fill="url(#paint0_linear_407_8583)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_407_8583"
          x={-53}
          y={-57.0198}
          width={213}
          height={213}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={20}
            result="effect1_foregroundBlur_407_8583"
          />
        </filter>
        <linearGradient
          id="paint0_linear_407_8583"
          x1={-43.8051}
          y1={23.0758}
          x2={107.4}
          y2={80.2802}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.695211} stopColor="#A2D5F1" />
          <stop offset={1} stopColor="#B0DAC1" stopOpacity={0.25} />
          <stop offset={1} stopColor="#ACCBE1" stopOpacity={0.487369} />
        </linearGradient>
      </defs>
    </svg>
  </SVGUniqueID>
)

export { BlurBlueCircle }
